import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { RiskCodesTooltip } from '@src/entities/RiskRecord/ui/components/tooltips/RiskCodes';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Table as TableComponent } from '@src/shared/ui/components/TableStatic';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Tooltip } from '@uhg-abyss/web/ui/Tooltip';
import { isUndefined } from 'lodash';
import React, { useMemo } from 'react';

import configuration from './includes/configuration.json';

/**
 * Table
 *
 * @TODO - Needs description.
 *
 * @param riskCodes
 * @param rows
 * @returns {Element}
 * @constructor
 */
export function Table({ riskCodes, rows }) {
  /**
   * renderCellAmount
   *
   * @TODO Needs description.
   *
   * @param cell
   * @returns {JSX.Element}
   */
  const renderCellAmount = ({ cell }) => {
    return <React.Fragment>{Number(cell?.value).toLocaleString('en-US')}</React.Fragment>;
  };

  /**
   * renderCellCode
   *
   * @TODO Needs description.
   *
   * @param cell
   * @returns {JSX.Element}
   */
  const renderCellCode = ({ cell }) => {
    const data = cell?.value?.split('-');

    const codeDescriptions = [];

    data.forEach((codeNumber) => {
      const match = riskCodes.find((riskCode) => {
        return riskCode?.codeId === String(codeNumber);
      });

      if (!isUndefined(match) && !codeDescriptions.includes(match)) {
        codeDescriptions.push(match);
      }
    });

    const letter = data.shift().toUpperCase();

    const badgeVariants = {
      G: 'success',
      R: 'error',
      Y: 'warning',
    };

    return (
      <Layout.Group space={Number(themeConfiguration?.theme?.space?.md) || 16}>
        <Badge outline variant={badgeVariants[letter]}>
          <Tooltip content={<RiskCodesTooltip codeDetails={codeDescriptions} />} placement="auto">
            <div>{cell?.value}</div>
          </Tooltip>
        </Badge>
      </Layout.Group>
    );
  };

  /**
   * Columns for table.
   */
  const columns = useMemo(() => {
    return configuration?.initialColumns.map((item) => {
      const column = item;

      if (column.Header === 'Code') {
        column.Cell = renderCellCode;
      }

      if (column.Header === 'Amount') {
        column.Cell = renderCellAmount;
      }

      return column;
    });
  }, []);

  return (
    <ErrorHandler location="src/widgets/RiskRecords/RiskCode/components/Table/Table.jsx">
      <TableComponent
        {...{
          columns,
          configuration,
          rows,
        }}
      />
    </ErrorHandler>
  );
}
